import React from "react"
import UnpackingIcon from "./icons/UnpackingIcon"
import CookingIcon from "./icons/CookingIcon"
import WeighingIcon from "./icons/WeighingIcon"
import TastingIcon from "./icons/TastingIcon"

import { PSES_SIDEBAR_MENUS_ENUM, PSES_SIDEBAR_MENUS_LABELS } from "../../../utils/productionStepExecution"
import ExecutionsSidebar from "../../Executions/ExecutionsSidebar"

const menus = [
	{ id: PSES_SIDEBAR_MENUS_ENUM.UNPACKING, label: PSES_SIDEBAR_MENUS_LABELS.UNPACKING, icon: UnpackingIcon },
	{ id: PSES_SIDEBAR_MENUS_ENUM.COOKING, label: PSES_SIDEBAR_MENUS_LABELS.COOKING, icon: CookingIcon },
	{ id: PSES_SIDEBAR_MENUS_ENUM.WEIGHING, label: PSES_SIDEBAR_MENUS_LABELS.WEIGHING, icon: WeighingIcon },
	{ id: PSES_SIDEBAR_MENUS_ENUM.TASTING, label: PSES_SIDEBAR_MENUS_LABELS.TASTING, icon: TastingIcon },
]

const PSEsSidebar = ({ selected, onSelect, isExpanded, onToggleExpand, notifications = {} }) => {
	const handleToggle = () => {
		onToggleExpand()
	}

	const handleSelect = (menuId) => {
		if (menuId === selected) return
		onSelect?.(menuId)
	}

	return (
		<ExecutionsSidebar
			selected={selected}
			onSelect={handleSelect}
			isExpanded={isExpanded}
			onToggleExpand={handleToggle}
			notifications={notifications}
			menus={menus}
		/>
	)
}

export default PSEsSidebar
